'use strict';

//dependencies included for running in node
if (typeof exports !== 'undefined') {
	if (typeof module !== 'undefined' && module.exports) {
		var ModelOutput = require('../lib/modelOutput');
		var AdvDate = require('js-utils/src/util/advDate');
	}
}

// FIXME: this needs sorting for non-whole year starting ages
// e.g. 64 and 11 months should be indexed from 64 pad out the first 11 months with 0's
// so getHistotyAtAge(65) returns the value of one months projection between 64, 11 months and 65

//wrapper for modelOutput for age based indexing and deflation
//NOTE: cash flow arrays are monthly

//TODO: ages passed should be objects in the form {years, months} to be able to query the cash flows in more detail
var AgeIndexedModelOutput = function(age) {
	this.modelOutput = new ModelOutput(age);
};

AgeIndexedModelOutput.prototype.useDeflatedOutput = function(deflator, period) {
	this.modelOutput.useDeflatedOutput(deflator, period);
};

AgeIndexedModelOutput.prototype.setValue = function(value) {
	this.modelOutput.setValue(value);
};

AgeIndexedModelOutput.prototype.getValue = function() {
	return this.modelOutput.getValue();
};

AgeIndexedModelOutput.prototype.getFullHistory = function() {
	return this.modelOutput.getFullHistory();
};

AgeIndexedModelOutput.prototype.getHistoryBetweenAges = function(startAge, endAge) {
	return this.modelOutput.getHistoryBetween(this.ageIndex(startAge), this.ageIndex(endAge));
};

AgeIndexedModelOutput.prototype.getHistoryAtAge = function(age) {
	return this.modelOutput.getHistoryAt(this.ageIndex(age));
};

AgeIndexedModelOutput.prototype.length = function() {
	return this.modelOutput.length();
};

AgeIndexedModelOutput.prototype.ageIndex = function(age) {
	return this.modelOutput.start + ((age - this.modelOutput.start) * AdvDate.MONTHS_IN_YEAR);
};

//Node module export
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = AgeIndexedModelOutput;
    }
    exports.AgeIndexedModelOutput = AgeIndexedModelOutput;
}